import { createRouter, createWebHistory } from 'vue-router';

import { logger } from '@/logs/datadog';
import { settings } from '@/references/settings/globals';
import ActivityView from '@/views/ActivityView.vue';
import BeneficiaryFormView from '@/views/BeneficiaryFormView.vue';
import BeneficiaryView from '@/views/BeneficiaryView.vue';
import Error404View from '@/views/Error404View.vue';
import HomeRootView from '@/views/HomeRootView.vue';
import HomeView from '@/views/HomeView.vue';
import LegalView from '@/views/LegalView.vue';
import OtcView from '@/views/OtcView.vue';
import RootView from '@/views/RootView.vue';
import SettingsView from '@/views/SettingsView.vue';
import WatchQuoteView from '@/views/WatchQuoteView.vue';

export const RouteNames = {
  Root: 'root',
  Home: 'home',
  Activity: 'activity',
  Settings: 'settings',
  Beneficiary: 'beneficiary',
  CreateBeneficiary: 'create-beneficiary',
  EditBeneficiary: 'edit-beneficiary',
  OTC: 'otc',
  WatchQuote: 'watch-quote',
  Legal: 'legal',
  Error404: '404'
} as const;

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: RootView,
      children: [
        /* Home */
        {
          path: '',
          component: HomeRootView,
          children: [
            {
              path: '',
              name: RouteNames.Home,
              component: HomeView
            },
            {
              path: 'activity/:id?',
              name: RouteNames.Activity,
              component: ActivityView,
              props: true,
              beforeEnter() {
                if (!settings.activityViewEnabled) {
                  return {
                    name: RouteNames.Home
                  };
                }
              }
            },
            {
              path: 'settings',
              name: RouteNames.Settings,
              component: SettingsView
            }
          ]
        },
        {
          path: 'beneficiary/:id',
          name: RouteNames.Beneficiary,
          component: BeneficiaryView,
          props: true
        },
        {
          path: 'beneficiary/create/:type',
          name: RouteNames.CreateBeneficiary,
          component: BeneficiaryFormView,
          props: true
        },
        {
          path: 'beneficiary/:id/edit',
          name: RouteNames.EditBeneficiary,
          component: BeneficiaryFormView,
          props: true
        },
        {
          path: 'otc/:id',
          name: RouteNames.OTC,
          component: OtcView,
          props: true
        },
        {
          path: 'quote/:id',
          name: RouteNames.WatchQuote,
          component: WatchQuoteView,
          props: true
        },
        {
          path: 'legal',
          name: RouteNames.Legal,
          component: LegalView
        }
      ]
    },

    /* 404. */
    {
      name: RouteNames.Error404,
      path: '/:pathMatch(.*)*',
      component: Error404View
    }
  ]
});

router.afterEach((to, _, failure) => {
  if (!failure) {
    logger.info(`navigation changed to ${to.fullPath}`, {
      routeName: to.name
    });
  }
});

export default router;
